export const EVENT_CHANNEL = 'media';

export const componentMetadata = {
	tableView: {
		component: 'datasourceTable',
	},
	configModal: {
		component: 'datasourceConfigModal',
	},
	generic: {
		component: 'datasource',
	},
};
